import * as React from 'react';
import {
	GetRailProps,
	GetHandleProps,
	GetTrackProps,
	SliderItem,
} from 'react-compound-slider';

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle = {
	position: 'absolute' as 'absolute',
	width: '100%',
	height: 42,
	transform: 'translate(0%, -50%)',
	borderRadius: 7,
	cursor: 'pointer',
};

interface SliderRailProps {
  getRailProps: GetRailProps;
}

export const SliderRail: React.FC<SliderRailProps> = ({ getRailProps } : any) => {
	return (
		<>
			<div className="modal-disable-select test-1" style={railOuterStyle} {...getRailProps()} />
			<div className="modal-disable-select bar" />
		</>
	);
};

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
interface HandleProps {
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
  disabled?: boolean;
  glowing?: boolean;
}

export const Handle: React.FC<HandleProps> = ({
	domain: [min, max],
	handle: { id, value, percent },
	disabled = false,
	glowing,
	getHandleProps,
} : any) => {
	return (
		<>
			<div className={`modal-disable-select fragment2`}
				style={{
					left: `${percent}%`,
				}}
			/>
			<div tabIndex={0} 
			aria-label="Drag until you hear a ping, then notify the bystander to call 9 1 1" 
			role="slider"
			className={`modal-disable-select fragment ${glowing ? 'glowing-knob' : ''}`}
				style={{
					left: `${percent}%`,
				}}
				{...getHandleProps(id)}
			/>
			<div className="test2 modal-disable-select"
				aria-label="Drag until you hear a ping, then notify the bystander to call 9 1 1" 
				role="slider"
				aria-valuemin={min}
				aria-valuemax={max}
				aria-valuenow={value}
				style={{
					left: `${percent}%`,
					position: 'absolute',
					transform: 'translate(-50%, -50%)',
					zIndex: 2,
					width: 24,
					height: 24,
					borderRadius: '50%',
					boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
					backgroundColor: disabled ? '#666' : '#9BBFD4',
					display: 'none'
				}}
			/>
		</>
	);
};

// *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************
export const KeyboardHandle: React.FC<HandleProps> = ({
	domain: [min, max],
	handle: { id, value, percent },
	disabled = false,
	getHandleProps,
} : any) => {
	return (
		<button className="test3 modal-disable-select"
			role="slider"
			aria-valuemin={min}
			aria-valuemax={max}
			aria-valuenow={value}
			style={{
				left: `${percent}%`,
				position: 'absolute',
				transform: 'translate(-50%, -50%)',
				zIndex: 2,
				width: 24,
				height: 24,
				borderRadius: '50%',
				boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
				backgroundColor: disabled ? '#666' : '#9BBFD4',
			}}
			{...getHandleProps(id)}
		/>
	);
};

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface TrackProps {
  source: SliderItem;
  target: SliderItem;
  getTrackProps: GetTrackProps;
  disabled?: boolean;
}

export const Track: React.FC<TrackProps> = ({
	source,
	target,
	getTrackProps,
	disabled = false,
} : any) => {
	return (
		<div className="test4 modal-disable-select"
			style={{
				position: 'absolute',
				transform: 'translate(0%, -50%)',
				height: 14,
				zIndex: 1,
				backgroundColor: disabled ? '#999' : '#607E9E',
				borderRadius: 7,
				cursor: 'pointer',
				left: `${source.percent}%`,
				width: `${target.percent - source.percent}%`,
			}}
			{...getTrackProps()}
		/>
	);
};

// *******************************************************
// TICK COMPONENT
// *******************************************************
interface TickProps {
  tick: SliderItem;
  count: number;
  format?: (val: number) => string;
}

export const Tick: React.FC<TickProps> = ({
	tick,
	count,
	format = (d : any) => d,
} : any) => {
	return (
		<div>
			<div className="test5 modal-disable-select"
				style={{
					position: 'absolute',
					marginTop: 14,
					width: 1,
					height: 5,
					backgroundColor: 'rgb(200,200,200)',
					left: `${tick.percent}%`,
				}}
			/>
			<div
				style={{
					position: 'absolute',
					marginTop: 22,
					fontSize: 10,
					textAlign: 'center',
					marginLeft: `${-(100 / count) / 2}%`,
					width: `${100 / count}%`,
					left: `${tick.percent}%`,
				}}
			>
				{format(tick.value)}
			</div>
		</div>
	);
};